import { Activity } from '../types/models'
import { Box } from '@mui/material'
import { DateTime } from 'luxon'
import { ActivityIcon } from './atoms/ActivityIcon'

export interface ActivityLineProps {
  activity: Activity
}

/**
 * User activity log.
 */
export function ActivityLine(props: ActivityLineProps): React.ReactElement {

  const { activity } = props

  const text: string = Object.keys(activity.params).reduce((prev, cur) => prev.replace(`{${cur}}`, JSON.stringify(activity.params[cur], null, 1)), activity.text)

  return (
    <Box sx={{
      mb: 0.5,
      display: 'grid',
      gridTemplateColumns: '2fr 1fr 14fr',
    }}>
      <Box>
        {DateTime.fromISO(activity.time).toLocal().toFormat('HH:mm:ss')}
      </Box>
      <Box>
        <ActivityIcon sx={{ height: '1rem' }} type={activity.type}/>
      </Box>
      <Box>
        {text}
      </Box>
    </Box>
  )
}
